import { orderBy, isEqual, union } from 'lodash'

import router from '@/router'
import { distanceFunc } from '@/components/filters_pipes/helper_functions'
import firebase from 'firebase/app'





export default {

  // This makes your getters, mutations, and actions accessed by, eg: 'myModule/myModularizedNumber' instead of mounting getters, mutations, and actions to the root namespace.
  namespaced: false,


  state: {
    menuItemsEvent: [
      { icon: 'fas fa-info-circle', title: 'Optionen demnächst verfügbar', method: '', deleteMethod: '', color: 'red--text', disabled: true },
      { icon: 'fas fa-exclamation-square', title: 'Aktivität Melden', disabled: true },
      { icon: 'fas fa-eye-slash', title: 'Event Ausblenden', disabled: true },
      { icon: 'fas fa-user-alt-slash', title: 'User nicht mehr anzeigen', disabled: true }
    ],
  
    menuItemsMoment: [
      { icon: 'fas fa-info-circle', title: 'Optionen demnächst verfügbar', method: '', deleteMethod: '', color: 'red--text', disabled: true },
      { icon: 'fas fa-exclamation-square', title: 'Aktivität Melden', disabled: true },
      { icon: 'fas fa-eye-slash', title: 'Moment Ausblenden', disabled: true },
      { icon: 'fas fa-user-alt-slash', title: 'User nicht mehr anzeigen', disabled: true }
    ],

    menuItemsEventUser: [
      // { icon: 'fas fa-edit', title: 'Bearbeiten' },
      { icon: 'fas fa-info-circle', title: 'Weitere Optionen demnächst verfügbar', method: '', deleteMethod: '', color: 'red--text', disabled: true },
      { icon: 'fas fa-edit', title: 'Bearbeiten', method: '', deleteMethod: '', disabled: true },
      { icon: 'fas fa-trash-alt', title: 'Löschen', method: 'deleteDialog', deleteMethod: 'deleteEventButton', disabled: false },
    ],
  
    menuItemsMomentUser: [
      // { icon: 'fas fa-edit', title: 'Bearbeiten' },
      { icon: 'fas fa-info-circle', title: 'Weitere Optionen demnächst verfügbar', method: '', deleteMethod: '', color: 'red--text', disabled: true },
      { icon: 'fas fa-edit', title: 'Bearbeiten', method: '', deleteMethod: '', disabled: true },
      { icon: 'fas fa-trash-alt', title: 'Löschen', method: 'deleteDialog', deleteMethod: 'deleteMomentButton', disabled: false },
    ],

    loadedEvents: [],
    loadedMoments: [],
    loadedFavEvents: [],
    loadedFavMoments: [],

    timelineScrollY: 0,
    noFilteredPosts: false,

    filteredPosts: [],

    timelineFilter: {
      selectedFilter: 'AppFilterOverview',
      filterText: 'Filter anpassen',
      filter_timelinedrawer: false,
      activeFilter: false,
      searchFilter: '',
      activityFilter: [],
      locationFilter: '',
      coordinatesFilter: {
        lat: '',
        lng: ''
      },
      distanceFilter: '',
      dateFilter: new Date().toISOString().substr(0, 10),
      categoriesFilter: []
    },

    timelineStandardFilter: {
      activityFilter: [],
      categoriesFilter: [],
      distanceFilter: '',
      locationFilter: '',
      coordinatesFilter: {}

    },

    timelineResetFilter: {
      searchFilter: '',
    
      activityFilter: [
        'events',
        'eventsbyfriends',
        'moments'
      ],
      locationFilter: '',
      coordinatesFilter: {},
      distanceFilter: 50,
      dateFilter: new Date().toISOString().substr(0, 10),
      categoriesFilter: [],
    }

    
  },


  getters: {
   

    // getAllPostsOrdered(state) {
      
    //   return orderBy(
    //     [
    //       ...state.loadedMoments.filter(function(value, index, arr) {
    //         if (value.distance) {
    //           return value.distance <= 50
    //         }
    //       }),
    //       ...state.loadedEvents.filter(function(value, index, arr) {
    //         if (value.distance) {
    //           return value.distance <= 50
    //         }
    //       })
    //     ],
    //     'date',
    //     'asc'
    //   )
      
    // },
    getAllPostsOrdered(state) {
      
      return orderBy(
        [
          ...state.loadedMoments,
          ...state.loadedEvents
        ],
        'date',
        'asc'
      )
      
    },
    
    getAllFilteredPostsOrdered(state) {
     
      return orderBy(state.filteredPosts,
        'date',
        'asc'
      )
      
      
    },
    getAllFavPosts(state) {
      return orderBy(
        [
          ...state.loadedFavEvents,
          ...state.loadedFavMoments
        ],
        'date',
        'asc'
      )
    },

    // Wieviel sollen angezeigt werden?
    // getfeaturedPosts(state, getters) {
    //   return getters.getAllPosts.slice(0, 3)
    // },

    getEvent(state) {
      return eventid => {
        return state.loadedEvents.find(event => {
          return event.id === eventid
        })
      }
    }
    // getByIndex: state => index => state.temp.events[index],
    // curryGetter: state => param => state.temp.events.find(id => id === param)
  },

  
  mutations: {
    setStandardFilter(state, payload) {
      for (const key in payload) {
        state.timelineStandardFilter[key] = payload[key]
      }
    },
    setResetFilter(state, payload) {
      for (const key in payload) {
        state.timelineResetFilter[key] = payload[key]
      }
    },
    setTimelineScrollY(state, payload) {
      state.timelineScrollY = payload
    },
    setNoFilteredPosts(state, payload) {
      state.noFilteredPosts = payload
      console.log('setNoFilteredPosts', payload)
    },

    setFilter(state, payload) {
      console.log('1', payload)
      for (const key in payload) {
        console.log('2', key)
        state.timelineFilter[key] = payload[key]
      }
    },

    // setCategoriesFilter(state, payload) {
    //   console.log('3', payload)

    //   for (const key in payload) {
    //     console.log('4', key)

    //     state.timelineFilter.categoriesFilter[key] = payload[key]
    //   }
    // },


    calcNewDistanceMoments(state, payload) {
      let usedLat = payload.lat
      let usedLng = payload.lng

      let momentsArray = state.loadedMoments


      for (let i in momentsArray) {

        let distanceReturn = distanceFunc({lat: usedLat, lng: usedLng}, momentsArray[i].coordinates)
        let distance = distanceReturn.distance
        let calcDistance = distanceReturn.calcDistance

      

        state.loadedMoments[i].distance = distance.toFixed(1)
        state.loadedMoments[i].calcDistance = calcDistance.toFixed(1)
      }

     
    },

    calcNewDistanceEvents(state, payload) {
      let usedLat = payload.lat
      let usedLng = payload.lng

      let eventsArray = state.loadedEvents


      for (let i in eventsArray) {

        let distanceReturn = distanceFunc({lat: usedLat, lng: usedLng}, eventsArray[i].coordinates)
        let distance = distanceReturn.distance
        let calcDistance = distanceReturn.calcDistance


        state.loadedEvents[i].distance = distance.toFixed(1)
        state.loadedEvents[i].calcDistance = calcDistance.toFixed(1)
      }

     
    },
    

    
    setActiveFilter(state, payload) {
      state.timelineFilter.activeFilter =  payload
      console.log('setActiveFilter', payload)
    },

    setSelectedFilter: (state, payload) => {
      state.timelineFilter.selectedFilter = payload.selectedFilter
      state.timelineFilter.filterText = payload.filterText
    },

    clicktimelinedrawer: (state, val) => {
      state.timelineFilter.filter_timelinedrawer = val
      state.timelineFilter.selectedFilter = 'AppFilterOverview'
      state.timelineFilter.filterText = 'Filter anpassen'
    },



    setFilteredPosts(state, payload) {
      state.filteredPosts = payload
    },
    setLoadedEvents (state, payload) {
      state.loadedEvents.push(payload)
    },
    setLoadedMoments (state, payload) {
      state.loadedMoments.push(payload)
    },
    deleteLoadedEvents (state, payload) {
      state.loadedEvents = []
    },
    deleteLoadedMoments (state, payload) {
      state.loadedMoments = []
    },
    setLoadedFavEvents (state, payload) {
      state.loadedFavEvents.push(payload)
    },
    setLoadedFavMoments (state, payload) {
      state.loadedFavMoments.push(payload)
    },
    deleteLoadedFavEvents (state, payload) {
      state.loadedFavEvents = []
    },
    deleteLoadedFavMoments (state, payload) {
      state.loadedFavMoments = []
    },
    // createEvent: (state, payload) => {
    //   // state.loadedEvents.push(payload)
    // },
    deleteFromLoadedMoments(state, payload) {
      var index = state.loadedMoments.findIndex(moment => moment.id === payload)
      state.loadedMoments.splice(index, 1)
    },
    deleteFromLoadedFavMoments(state, payload) {
      var index = state.loadedFavMoments.findIndex(favmoment => favmoment.id === payload.id)
      state.loadedFavMoments.splice(index, 1)
    },
    deleteFromLoadedEvents(state, payload) {
      var index = state.loadedEvents.findIndex(event => event.id === payload)
      state.loadedEvents.splice(index, 1)
    },
    deleteFromLoadedFavEvents(state, payload) {
      var index = state.loadedFavEvents.findIndex(favevent => favevent.id === payload.id)
      state.loadedFavEvents.splice(index, 1)
    },
    changeFavMoments(state, payload) {
      var indexMoment = state.loadedMoments.findIndex(moment => moment.id === payload.id)
      state.loadedMoments[indexMoment].favMoment = payload.favMoment
      state.loadedMoments[indexMoment].subscribersNum = state.loadedMoments[indexMoment].subscribersNum + payload.subscribersNum
    },
    changeFavEvents(state, payload) {
      var index = state.loadedEvents.findIndex(event => event.id === payload.id)
      state.loadedEvents[index].favEvent = payload.favEvent
      state.loadedEvents[index].subscribersNum = state.loadedEvents[index].subscribersNum + payload.subscribersNum
    }
    // changeNotification (state, payload) {
    //   var index = state.notifications.findIndex(not => not.notificationId === payload.notificationId)
    //   state.notifications[index].new = false
    // },
  },

  actions: {
    resetFilter({commit, state, rootState, dispatch}, payload) {
      
      let categories = []
      for (const key of Object.keys(rootState.categories)) {
        categories.push(key)
      }

      let resetFilter = {
        searchFilter: '',
        activityFilter: [
          'events',
          'eventsbyfriends',
          'moments'
        ],
        // locationFilter: state.timelineStandardFilter.locationFilter,
        // coordinatesFilter: state.timelineStandardFilter.coordinatesFilter,
        distanceFilter: 50,
        dateFilter: new Date().toISOString().substr(0, 10),
        categoriesFilter: categories,
      }

      commit('setFilteredPosts', [])
      commit('setActiveFilter', false)
      commit('setNoFilteredPosts', false)
      commit('setFilter', resetFilter)
      dispatch('filterPosts', {isFilterSet: true})
    },




    filterPosts({commit, dispatch, state, rootState, getters}, payload) {
      commit('setActiveFilter', false)
      commit('setNoFilteredPosts', false)


      let allPosts = getters.getAllPostsOrdered
      console.log('imFilterAllPosts', allPosts)
      let timelineFilter = state.timelineFilter
      let timelineResetFilter = state.timelineResetFilter

      let allCategoriesAry = []
      for (const key of Object.keys(rootState.categories)) {
        allCategoriesAry.push(key)
      }

      console.log('checkfilterposts', payload)

      // check if another Location is set
      if (!(isEqual(timelineFilter.coordinatesFilter, timelineResetFilter.coordinatesFilter))) {
        console.log('Filter6_Location', timelineFilter.coordinatesFilter)

        // set oldCoordinates
        let oldLat = timelineResetFilter.coordinatesFilter.lat
        let oldLng = timelineResetFilter.coordinatesFilter.lng

        let oldLatRounded = ((Math.round((oldLat * 10) / 5) * 5) / 10).toFixed(1)
        let oldLngRounded = ((Math.round((oldLng * 10) / 5) * 5) / 10).toFixed(1)

        let oldLatRoundedNum = parseFloat(oldLatRounded)
        let oldLngRoundedNum = parseFloat(oldLngRounded)

        // set newCoordinates
        let newLat = timelineFilter.coordinatesFilter.lat
        let newLng = timelineFilter.coordinatesFilter.lng

        let newLatRounded = ((Math.round((newLat * 10) / 5) * 5) / 10).toFixed(1)
        let newLngRounded = ((Math.round((newLng * 10) / 5) * 5) / 10).toFixed(1)

        let newLatRoundedNum = parseFloat(newLatRounded)
        let newLngRoundedNum = parseFloat(newLngRounded)

        console.log('old_coordinates', oldLatRoundedNum, oldLngRoundedNum)
        console.log('new_coordinates', newLatRoundedNum, newLngRoundedNum)

        // wenn Coordinaten auf eine Nachkommastell .5 abweichen
        // -> Events neu laden
        // -> Moments Entfernung neu berechnen
        // -> ResetFilter Location & Coordinates aktualisieren
        if(oldLatRoundedNum !== newLatRoundedNum || oldLngRoundedNum !== newLngRoundedNum) {
          console.log('lat_diff', oldLatRoundedNum, newLatRoundedNum)
          console.log('lng_diff', oldLngRoundedNum, newLngRoundedNum)

          dispatch('loadEvents', timelineFilter.coordinatesFilter)

          commit('calcNewDistanceMoments', timelineFilter.coordinatesFilter)

          let newTimelineResetFilter = {
            locationFilter: timelineFilter.locationFilter,
            coordinatesFilter: timelineFilter.coordinatesFilter
          }
          commit('setResetFilter', newTimelineResetFilter)

          setTimeout(function() {
            dispatch('filterPosts', {isFilterSet: true})

          }, 1500)
        } else {
          // wenn Coordinaten nur auf .toFixed(3) abweichen
          // -> Events Entfernung neu berechnen
          // -> Moments Entfernung neu berechnen
          // -> ResetFilter Location & Coordinates aktualisieren
          commit('calcNewDistanceMoments', timelineFilter.coordinatesFilter)
          commit('calcNewDistanceEvents', timelineFilter.coordinatesFilter)


          let newTimelineResetFilter = {
            locationFilter: timelineFilter.locationFilter,
            coordinatesFilter: timelineFilter.coordinatesFilter
          }
          commit('setResetFilter', newTimelineResetFilter)

          setTimeout(function() {
            dispatch('filterPosts', {isFilterSet: true})

          }, 1500)

        } 
      } else {



     

        var filterTimeline = new Promise(function(resolve, reject) {
          if (payload.isFilterSet) {
            resolve(allPosts)
          } else {
            reject(new Error('IsFilterSet -> false'))
          }
        })
      
            
      
        filterTimeline
          
          .then((filteredPosts) => {
            if (filteredPosts !== null) {
              return filteredPosts
            } else {
              console.log('filternNeuStarten')
              dispatch('filterPosts', {isFilterSet: true})
              
            }
          })
          .then((filteredPosts)=> {
            if (timelineFilter.searchFilter !== '') {
              console.log('Filter1_Search', timelineFilter.searchFilter)
      
              let search = timelineFilter.searchFilter.toLowerCase()
      
              let titleArray = filteredPosts.filter(function(value, index, arr) {
                if (value.title) {
                  return value.title.toLowerCase().includes(search)
                }
              })
            
              let descriptionArray = filteredPosts.filter(function(value, index, arr) {
                if (value.description) {
                  return value.description.toLowerCase().includes(search)
                }
              })
              let mainCatArray = filteredPosts.filter(function(value, index, arr) {
                if (value.mainCat) {
                  return value.mainCat.toLowerCase().includes(search)
                }
              })
              let secondCatArray = filteredPosts.filter(function(value, index, arr) {
                if (value.secondCat) {
                  return value.secondCat.toLowerCase().includes(search)
                }
              })
              let locationArray = filteredPosts.filter(function(value, index, arr) {
                if (value.location) {
                  return value.location.toLowerCase().includes(search)
                }
              })
              let nameArray = filteredPosts.filter(function(value, index, arr) {
                if (value.name) {
                  return value.name.toLowerCase().includes(search)
                }
              })
              let uniqueIdArray = filteredPosts.filter(function(value, index, arr) {
                if (value.uniqueId) {
                  return value.uniqueId.toLowerCase().includes(search)
                }
              })
            
              let filteredSearchArray = union(titleArray, descriptionArray, mainCatArray, secondCatArray, locationArray, nameArray, uniqueIdArray)
            
              console.log('allPosts', allPosts)
              console.log('filteredSearchArray', filteredSearchArray)
            
              // commit('setFilteredPosts', filteredSearchArray)
              commit('setActiveFilter', true)
            
              return filteredSearchArray
            } else {
              return filteredPosts
            }
          })
          .then((filteredPosts) => {
            if (!(isEqual(timelineFilter.activityFilter.concat().sort(), timelineResetFilter.activityFilter.concat().sort()))) {
              console.log('Filter2_Activity', timelineFilter.activityFilter)
      
              let filteredActivityArray = []
              let activity = []
              for (let i = 0; i < timelineFilter.activityFilter.length; i++) {
                activity[i] = filteredPosts.filter(function(value, index, arr) {
                  if (value.subject) {
                    return value.subject.includes(timelineFilter.activityFilter[i])
                  }
                })
                // console.log('i', i, timelineFilter.activityFilter[i], activity[i])
                filteredActivityArray = union(filteredActivityArray, activity[i])
              }
              // console.log('allPosts', allPosts)
              // console.log('filteredActivityArray', filteredActivityArray)
              commit('setActiveFilter', true)
              
              return filteredActivityArray
            } else {
              return filteredPosts
            }
      
          })
             
          .then((filteredPosts) => {
            if (timelineFilter.dateFilter !== new Date().toISOString().substr(0, 10)) {
              console.log('Filter3_Date', timelineFilter.dateFilter)
      
              let filteredDateArray = filteredPosts.filter(function(value, index, arr) {
                if (value.date) {
                  return value.date >= timelineFilter.dateFilter
                }
              })
              commit('setActiveFilter', true)
              return filteredDateArray
            } else {
              return filteredPosts
            }
          })
              
          .then((filteredPosts) => {
            if (timelineFilter.categoriesFilter.length !== 0 && timelineFilter.categoriesFilter.length !== allCategoriesAry.length) {
              console.log('Filter4_Categories', timelineFilter.categoriesFilter)
      

              let filteredCategoriesArray = []
              let mainCatAry = []
              let secondCatAry = []

              for (let i = 0; i < timelineFilter.categoriesFilter.length; i++) {
                mainCatAry[i] = filteredPosts.filter(function(value, index, arr) {
                  if (value.mainCat) {
                    return value.mainCat.includes(timelineFilter.categoriesFilter[i])
                  }
                })
                secondCatAry[i] = filteredPosts.filter(function(value, index, arr) {
                  if (value.secondCat) {
                    return value.secondCat.includes(timelineFilter.categoriesFilter[i])
                  }
                })
                filteredCategoriesArray = union(filteredCategoriesArray, mainCatAry[i], secondCatAry[i])
              }
      
      
              commit('setActiveFilter', true)
              return filteredCategoriesArray
            } else {
              return filteredPosts
            }
          })
          .then((filteredPosts) => {
            if (timelineFilter.distanceFilter !== timelineResetFilter.distanceFilter) {
              console.log('Filter5_Distance', timelineFilter.distanceFilter)
      
              let filteredDistanceArray = filteredPosts.filter(function(value, index, arr) {
                if (value.distance) {
                  return value.distance <= timelineFilter.distanceFilter
                }
              })
                    
              
              commit('setActiveFilter', true)
              return filteredDistanceArray
            } else {
              return filteredPosts
            }
          })
          // .then((payload) => {
          //   if (!(isEqual(timelineFilter.locationFilter, timelineResetFilter.locationFilter))) {
          //     console.log('Filter6_Location', timelineFilter.locationFilter)
          //   }
          //   return payload
          // })
          .then((filteredPosts) => {
            console.log('endOfFilter', filteredPosts)
            console.log('activeFilter', state.timelineFilter.activeFilter)
            // if (filteredPosts.length === allPosts.length) {
            //   commit('setActiveFilter', false)
      
            // } else 
            // if (filteredPosts.length === 0 && state.timelineFilter.activeFilter === true) {
            if (state.timelineFilter.activeFilter !== true) {
              console.log('kein Filter gefunden')
              // commit('setActiveFilter', false)

            } else if (state.timelineFilter.activeFilter === true && filteredPosts.length === 0) {
              console.log('kein Filter gefunden')
              commit('setNoFilteredPosts', true)

            } else {
              // commit('setActiveFilter', true)
              let distance50 = filteredPosts.filter(post => {
                return post.distance < 50
              })

              if (distance50.length > 0) {
                commit('setFilteredPosts', filteredPosts)
              } else {
                commit('setNoFilteredPosts', true)

              }

              if (filteredPosts.length === allPosts.length && state.timelineFilter.activeFilter !== true) {
                commit('setNoFilteredPosts', true)
              }
            }
      
          })
          .catch((error) => {
            console.log('error', error)
          })
            
           
      
       
      }





     

      // if (payload.reset) {
      //   commit('setFilteredPosts', [])
      //   commit('setActiveFilter', false)
      // } else if (payload.activity) {
      //   console.log('filteractivity', payload.activity)

      //   let subjectEvent = allPosts.filter(function(value, index, arr) {
      //     if (value.subject) {
      //       return value.subject.includes(payload.activity[0])
      //     }
      //   })

      //   let subjectMoment = allPosts.filter(function(value, index, arr) {
      //     if (value.subject) {
      //       return value.subject.includes(payload.activity[1])
      //     }
      //   })

      //   let subjectFriendEvent = allPosts.filter(function(value, index, arr) {
      //     if (value.subject) {
      //       return value.subject.includes(payload.activity[2])
      //     }
      //   })

      //   let filteredArray = union(subjectEvent, subjectMoment, subjectFriendEvent)

      //   console.log('allPosts', allPosts)
      //   console.log('filteredArray', filteredArray)

      //   commit('setFilteredPosts', filteredArray)
      //   commit('setActiveFilter', true)
      // }

      // if (payload.search) {
      //   console.log('filtersearch', payload.search)
      //   // commit('setFilter', payload.search)

      //   let search = payload.search.toLowerCase()

      //   let titleArray = allPosts.filter(function(value, index, arr) {
      //     if (value.title) {
      //       return value.title.toLowerCase().includes(search)
      //     }
      //   })

      //   let descriptionArray = allPosts.filter(function(value, index, arr) {
      //     if (value.description) {
      //       return value.description.toLowerCase().includes(search)
      //     }
      //   })
      //   let mainCatArray = allPosts.filter(function(value, index, arr) {
      //     if (value.mainCat) {
      //       return value.mainCat.toLowerCase().includes(search)
      //     }
      //   })
      //   let secondCatArray = allPosts.filter(function(value, index, arr) {
      //     if (value.secondCat) {
      //       return value.secondCat.toLowerCase().includes(search)
      //     }
      //   })
      //   let locationArray = allPosts.filter(function(value, index, arr) {
      //     if (value.location) {
      //       return value.location.toLowerCase().includes(search)
      //     }
      //   })
      //   let nameArray = allPosts.filter(function(value, index, arr) {
      //     if (value.name) {
      //       return value.name.toLowerCase().includes(search)
      //     }
      //   })
      //   let uniqueIdArray = allPosts.filter(function(value, index, arr) {
      //     if (value.uniqueId) {
      //       return value.uniqueId.toLowerCase().includes(search)
      //     }
      //   })

      //   let filteredArray = union(titleArray, descriptionArray, mainCatArray, secondCatArray, locationArray, nameArray, uniqueIdArray)

      //   console.log('allPosts', allPosts)
      //   console.log('filteredArray', filteredArray)

      //   commit('setFilteredPosts', filteredArray)
      //   commit('setActiveFilter', true)

      // }
    },



    loadEvents ({rootState, state, commit}, payload) {
      console.log('loadEvents')

      commit('setLoadingEvents', true)
      commit('deleteLoadedEvents')

      let user = rootState.user.user

      let date = new Date()
      let dateminus1day = new Date(date.setDate(date.getDate() - 1)).toISOString()


      let usedLat
      let usedLng

      

      // set UserCoords
      let userLat = user.filter.coordinates.lat
      let userLng = user.filter.coordinates.lng

      if (payload) {
        usedLat = payload.lat
        usedLng = payload.lng
      } else {
        usedLat = userLat
        usedLng = userLng
      }

      let dblat = ((Math.round((usedLat * 10) / 5) * 5) / 10).toFixed(1)
      let dblng = ((Math.round((usedLng * 10) / 5) * 5) / 10).toFixed(1)

      let dblatNum = parseFloat(dblat)
      let dblngNum = parseFloat(dblng)
      // console.log('start', dblat, dblng)


      function getEventsFromDB(forlat, forlng) {
        firebase.firestore().collection('activity').doc('events').collection(forlat.toFixed(1) + ',' + forlng.toFixed(1)).where('date', '>=', dateminus1day).orderBy('date').get()
          .then((eventSnapshot) => {
            eventSnapshot
              .forEach((docEvent) => {
              
                const obj = docEvent.data()
              
                let distanceReturn = distanceFunc({lat: usedLat, lng: usedLng}, obj.coordinates)
                let distance = distanceReturn.distance
                let calcDistance = distanceReturn.calcDistance

                // let dx = 71.5 * (usedLng.toFixed(3) - obj.coordinates.lng.toFixed(3))
                // let dy = 111.3 * (usedLat.toFixed(3) - obj.coordinates.lat.toFixed(3))
              
                // let distance  = (Math.sqrt(dx * dx + dy * dy))
                
                // let calcDistance

                // if (distance < 10) {
                //   calcDistance = distance
                // } else if (distance < 20) {
                //   calcDistance = (distance + 2.2)
                // } else if (distance < 30) {
                //   calcDistance = (distance + (2 * 2.2))
                // } else if (distance < 40) {
                //   calcDistance = (distance + (3 * 2.2))
                // } else if (distance < 50) {
                //   calcDistance = (distance + (4 * 2.2))
                // } else {
                //   calcDistance = (distance + (5 * 2.2))
                // }
              
              
                let newEvent = {
                  id: docEvent.id,
                  subject: obj.subject,
                  title: obj.title,
                  location: obj.location,
                  coordinates: obj.coordinates,
                  date: obj.date,
                  mainCat: obj.mainCat,
                  secondCat: obj.secondCat,
                  description: obj.description,
                  imgUrl: obj.imgUrl,
                  standardImage: obj.standardImage,
                  link: obj.link,
                  distance: distance.toFixed(1),
                  calcDistance: calcDistance.toFixed(1),
                  creatorId: obj.creatorId,
                  uniqueId: obj.uniqueId,
                  createdTime: obj.createdTime,
                  dblat: obj.dblat,
                  dblng: obj.dblng,
                }
                if (distance <= 50) {
                  firebase.firestore().collection('activity').doc('events').collection(obj.dblat + ',' + obj.dblng).doc(docEvent.id).collection('subscribers').get()
                    .then((subscribersSnapshot) => {
                      newEvent.subscribersNum = subscribersSnapshot.size
                    })
                    .then(()=>{
                      firebase.firestore().collection('activity').doc('events').collection(obj.dblat + ',' + obj.dblng).doc(docEvent.id).collection('subscribers').doc(user.id).get()
                        .then((doc) => {
                          if (doc.exists) {
                            newEvent.favEvent = true
                          } else {
                            newEvent.favEvent = false
                          }
                        })
                        .catch((error) => {
                          console.log(error)
                        })
                    })
                    .then(()=> {
                      commit('setLoadedEvents', newEvent)
                    // console.log('eventAdded', newEvent)
                    })
                    .catch((error) => {
                      console.log(error)
                    })
                }
                
                              
              })
                              
          })
          .catch((error) => {
            console.log(error)
            // commit('setLoadingEvents', false)
            setTimeout(function() {
              commit('setLoadingEvents', false)
            }, 1111)
          })
      }


      
      function eventsDBPromise() {
        let getEventsfromDB = new Promise((resolve, reject) => {
          resolve()
        })

        getEventsfromDB
          .then(() => {
            for (var forlat = dblatNum - 0.5; forlat <= dblatNum + 0.5; forlat = forlat + 0.5) {
              for (var forlng = dblngNum - 0.5; forlng <= dblngNum + 0.5; forlng = forlng + 0.5) {
              
                // console.log(forlat.toFixed(1), forlng.toFixed(1))
              
                getEventsFromDB(forlat, forlng)
                
                if (forlat === dblatNum + 0.5 && forlng === dblngNum + 0.5) {
                  console.log('ready', forlat, forlng)
                  // getEventsFromDB(forlat, forlng)
                } else {
                  console.log('notready', forlat, forlng)
                  // getEventsFromDB(forlat, forlng)
                }
              }
             
            }
            
          })
          .then(() => {
            // if (forlat === dblatNum + 0.5) {
            // commit('setLoadingEvents', false)
            console.log('loadEvents -> done', state.loadedEvents)
              
            setTimeout(function() {
              commit('setLoadingEvents', false)
            }, 1111)
          
            // }
          })
      }
       
      
     
      return eventsDBPromise()
       
      
    },
    

    


    createEvent({ commit, rootState, state, dispatch }, payload) {
      commit('setLoading', true)

      commit('clearError')
  
      let user = firebase.auth().currentUser
      // console.log('user', user)
      console.log('payloadEvent', payload)
      if (user) { 
        
        // let lat = parseInt(payload.coordinates.lat, 10).toString()
        // let lng = parseInt(payload.coordinates.lng, 10).toString()
        // let dblat = ((Math.round(payload.coordinates.lat * 10) / 10).toFixed(1))
        // let dblng = ((Math.round(payload.coordinates.lng * 10) / 10).toFixed(1))
        let dblat = ((Math.round((payload.coordinates.lat * 10) / 5) * 5) / 10).toFixed(1)
        let dblng = ((Math.round((payload.coordinates.lng * 10) / 5) * 5) / 10).toFixed(1)
        let imgUrl = ''
        let key
        let path

        const event = {
          subject: 'events',
          title: payload.title,
          location: payload.location,
          coordinates: payload.coordinates,
          date: payload.date.toISOString(),
          description: payload.description,
          mainCat: payload.mainCat,
          secondCat: payload.secondCat,
          link: payload.link,
          creatorId: user.uid,
          uniqueId: rootState.user.user.uniqueId,
          createdTime: new Date().toISOString(),
          dblat: dblat,
          dblng: dblng,
          imgUrl: imgUrl,
          standardImage: payload.standardImage
        }
        firebase.firestore().collection('activity').doc('events').collection(dblat + ',' + dblng).add(event)
          .then(function(docRef) {
            console.log('data', docRef)
            key = docRef.id
            path = docRef.path
            return key
          })
          .then(key => {
            // only if Event is created by User
          
            if (payload.image !== null) {
              return firebase.storage().ref('activity/events/' + user.uid).child(key).child(key).put(payload.image)
            } else {
              // When StartEvent is created
              
            }
           
          })
          .then(fileData => {
            // only if Event is created by User
            if (payload.image !== null) {
              let imagePath = fileData.metadata.fullPath
              return firebase.storage().ref().child(imagePath).getDownloadURL()
                .then(url => {
                  imgUrl = url
                  return firebase.firestore().collection('activity').doc('events').collection(dblat + ',' + dblng).doc(key).update({imgUrl: imgUrl})
                })
            }
            
          })
          .then((data) => {
            const createdEvent = {
              id: key,
              path: path,
              dblat: dblat,
              dblng: dblng
            }
            firebase.firestore().collection('users').doc(user.uid).collection('createdEvents').doc(key).set(createdEvent)
              .then(() => {
                // created path
              })
              .catch((error) => {
                commit('setLoading', false)
                console.log(error)
              })


            let distanceReturn = distanceFunc({lat: rootState.user.user.filter.coordinates.lat, lng: rootState.user.user.filter.coordinates.lng}, payload.coordinates)
            let distance = distanceReturn.distance
            let calcDistance = distanceReturn.calcDistance

            const newEvent = {
              id: key,
              subject: 'events',
              title: payload.title,
              location: payload.location,
              coordinates: payload.coordinates,
              date: payload.date.toISOString(),
              mainCat: payload.mainCat,
              secondCat: payload.secondCat,
              description: payload.description,
              link: payload.link,
              imgUrl: imgUrl,
              standardImage: payload.standardImage,
              subscribersNum: 0,
              favEvent: false,
              creatorId: user.uid,
              uniqueId: rootState.user.user.uniqueId,
              distance: distance.toFixed(1),
              calcDistance: calcDistance.toFixed(1),
              createdTime: new Date().toISOString(),
              dblat: dblat,
              dblng: dblng
            }
            console.log('newEventcreated', newEvent)
            commit('setLoadedEvents', newEvent)
            
          })
          .then(() => {
            // console.log('loadedEvents', state.loadedEvents)
            // console.log('getAllPostsOrdered', state.getAllPostsOrdered)
            dispatch('filterPosts', {isFilterSet: true})
          })
          .then(() => {
    
            commit('setLoading', false)
            router.push('/timeline')
    
          })
          .catch((error) => {
            commit('setLoading', false)
            console.log(error)
          })
      }
    },

    deleteEvent({commit}, payload) { 
      
      commit('clearError')
      let user = firebase.auth().currentUser
      if (user.uid === payload.creatorId) {
        console.log(payload)
        firebase.firestore().collection('activity').doc('events').collection(payload.post.dblat + ',' + payload.post.dblng).doc(payload.eventId).delete()
          .then(() => {
            // Storage - EventHeaderImage löschen
            var headerImgRef = firebase.storage().ref()
            headerImgRef.child('activity/events/' + user.uid + '/' + payload.eventId + '/' + payload.eventId).delete()
              .then(function() {
                // File deleted successfully
                console.log('HeaderImg deleted')
              })
              .catch(function(error) {
                // Uh-oh, an error occurred!
                console.log(error)
              })
          })
          .then(() => {
            firebase.firestore().collection('activity').doc('events').collection(payload.post.dblat + ',' + payload.post.dblng).doc(payload.eventId).collection('subscribers').get()
              .then((subscribersSnapshot)  => {
                subscribersSnapshot.forEach((subscriberDoc) => {
                  firebase.firestore().collection('activity').doc('events').collection(payload.post.dblat + ',' + payload.post.dblng).doc(payload.eventId).collection('subscribers').doc(subscriberDoc.id).delete()
                    .then(function() {
                      console.log('Document successfully deleted!')
                    }).catch(function(error) {
                      console.error('Error removing document: ', error)
                    })
                })
              })

          })
          .then(()=> {
            firebase.firestore().collection('users').doc(user.uid).collection('createdEvents').doc(payload.eventId).delete()
              .then(function() {
                console.log('Document successfully deleted!')
              }).catch(function(error) {
                console.error('Error removing document: ', error)
              })
          })
          .then(function() {
            console.log('Document successfully deleted!')
            commit('deleteFromLoadedEvents', payload.eventId)
            commit('deleteFromLoadedFavEvents', {id: payload.eventId})
            // router.go()
          }).catch(function(error) {
            console.error('Error removing document: ', error)
          })
      
      }
    },





    loadMoments ({rootState, state, commit}) {
      console.log('start_loadMoments')
      commit('setLoadingMoments', true)
      commit('deleteLoadedMoments')

      // set User Friends
      let friends = rootState.user.myFriends
      let date = new Date()
      let dateminus1day = new Date(date.setDate(date.getDate() - 1)).toISOString()

      let user = rootState.user.user
      
      
      console.log('userStat', user)

      // load Users (self) Moments
      return firebase.firestore().collection('activity').doc('moments').collection(user.id).where('date', '>=', dateminus1day).orderBy('date').get()
      // firebase.firestore().collection('activity').doc('moments').collection('NYOCbemeFSbmWhgeldQAUMjZMut2').get()
        .then((momentSnapshot) => {
          
          const userName = user.name
          const userProfileImg = user.profileImg
          const userUniqueId = user.uniqueId
          momentSnapshot.forEach((docMoment) => {
            // console.log('query', doc)
      
            const obj = docMoment.data()


            let distanceReturn = distanceFunc({lat: user.filter.coordinates.lat, lng: user.filter.coordinates.lng}, obj.coordinates)
            let distance = distanceReturn.distance
            let calcDistance = distanceReturn.calcDistance



            let newMoment = {
              id: docMoment.id,
              subject: obj.subject,
              title: obj.title,
              location: obj.location,
              coordinates: obj.coordinates,
              date: obj.date,
              mainCat: obj.mainCat,
              secondCat: obj.secondCat,
              description: obj.description,
              name: userName,
              distance: distance.toFixed(1),
              calcDistance: calcDistance.toFixed(1),
              imgUrl: userProfileImg,
              uniqueId: userUniqueId,
              creatorId: obj.creatorId,
              createdTime: obj.createdTime
            }

            // if (distance <= 50) {
            firebase.firestore().collection('activity').doc('moments').collection(user.id).doc(docMoment.id).collection('subscribers').get()
              .then((subscribersSnapshot) => {
                newMoment.subscribersNum = subscribersSnapshot.size
              })
              .then(() => {
                firebase.firestore().collection('activity').doc('moments').collection(user.id).doc(docMoment.id).collection('subscribers').doc(user.id).get()
                  .then((doc) => {
                    if (doc.exists) {
                      newMoment.favMoment = true
                    } else {
                      newMoment.favMoment = false
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              })
              .then(() => {
               
                commit('setLoadedMoments', newMoment)
                // console.log('momentAdded', newMoment)
                
              })
              .catch((error) => {
                console.log(error)
              })

            // }
            
            
          })
            
           
            
        })
        .then(() => {
          // load Moments from Friends
          console.log('momentsFriends', friends)

          if (friends.length > 0) {
            for (let numFriends = 0; numFriends < friends.length; numFriends++) {
              console.log('numFriends', numFriends, friends[numFriends])
              if (friends[numFriends].acceptedByFriend === true && friends[numFriends].acceptedByUser === true) { 
                return firebase.firestore().collection('activity').doc('moments').collection(friends[numFriends].friendId).where('date', '>=', dateminus1day).orderBy('date').get()
                  .then((momentSnapshot) => {
                    firebase.firestore().collection('users').doc(friends[numFriends].friendId).get()
                      .then((userDoc) => {

                        const userName = userDoc.data().name
                        const userProfileImg = userDoc.data().profileImg
                        const userUniqueId = userDoc.data().uniqueId
                        momentSnapshot.forEach((docMoment) => {
                          // console.log('query', doc)
          
                          const obj = docMoment.data()

                          let distanceReturn = distanceFunc({lat: user.filter.coordinates.lat, lng: user.filter.coordinates.lng}, obj.coordinates)
                          let distance = distanceReturn.distance
                          let calcDistance = distanceReturn.calcDistance



                          const newMoment = {
                            id: docMoment.id,
                            subject: obj.subject,
                            title: obj.title,
                            location: obj.location,
                            coordinates: obj.coordinates,
                            date: obj.date,
                            mainCat: obj.mainCat,
                            secondCat: obj.secondCat,
                            description: obj.description,
                            name: userName,
                            distance: distance.toFixed(1),
                            calcDistance: calcDistance.toFixed(1),
                            imgUrl: userProfileImg,
                            uniqueId: userUniqueId,
                            creatorId: obj.creatorId,
                            createdTime: obj.createdTime,
                          }

                          // if (distance <= 50) {
                          firebase.firestore().collection('activity').doc('moments').collection(friends[numFriends].friendId).doc(docMoment.id).collection('subscribers').get()
                            .then((subscribersSnapshot) => {
                              newMoment.subscribersNum = subscribersSnapshot.size
                            })
                            .then(() => {
                              firebase.firestore().collection('activity').doc('moments').collection(friends[numFriends].friendId).doc(docMoment.id).collection('subscribers').doc(user.id).get()
                                .then((doc) => {
                                  if (doc.exists) {
                                    newMoment.favMoment = true
                                  } else {
                                    newMoment.favMoment = false
                                  }
                                })
                                .catch((error) => {
                                  console.log(error)
                                })
                            })
                            .then(() => {
               
                              commit('setLoadedMoments', newMoment)
                              // console.log('momentAdded', newMoment)
                              
                            })
                            .catch((error) => {
                              console.log(error)
                            })
                          // }
                          

                        })
                      })
                      .catch((error) => {
                        console.log(error)
                        commit('setError', error)
                      })
                
                  })
                 
                  
                  .catch((error) => {
                    console.log(error)
                  })
              }
            }
          } 

        })
        .then(() => {
          // commit('setLoadingMoments', false)
          console.log('loadMoments -> done', state.loadedMoments)

          setTimeout(function() {
            commit('setLoadingMoments', false)
          }, 111)


        })
       
          
        .catch((error) => {
          console.log(error)
          // commit('setLoadingMoments', false)
          setTimeout(function() {
            commit('setLoadingMoments', false)
          }, 111)

        })


      
    },


    loadFavMoments ({rootState, state, commit}, payload) {
      console.log('loadFavMoments')
      commit('setLoadingFavMoments', true)
      // commit('deleteLoadedFavMoments')
      
      let user = rootState.user.user

      // set User Friends
      let friends = rootState.user.myFriends
      let favMoments = rootState.user.favMoments
      let loadedFavMoments = state.loadedFavMoments

      
      
      console.log('userStat', user)

      // load Fav Moments
      for (let key in Object.keys(favMoments)) {
        console.log(key, '=>', favMoments[key])

        var momentLoaded = loadedFavMoments.some(function(value) {
          return value.id === favMoments[key].id
        })

        if (!momentLoaded) {
          // console.log(loadedFavMoments)
          // console.log('newloading', momentLoaded)
          // load Info of Moment
          firebase.firestore().collection('activity').doc('moments').collection(favMoments[key].creatorId).doc(favMoments[key].id).get()
            .then(function(docMoment) {
              if (docMoment.exists) {
                console.log('Document data:', docMoment.data())
            
                const obj = docMoment.data()

                let userName
                let userProfileImg
                let userUniqueId

                if (favMoments[key].creatorId === user.id) {
                  userName = user.name
                  userProfileImg = user.profileImg
                  userUniqueId = user.uniqueId
                } else {

                  var friendInfo = friends.filter(function(value, index, arr) {
                    return value.friendId === obj.creatorId
                  })

                  userName = friendInfo.name
                  userProfileImg = friendInfo.profileImg
                  userUniqueId = friendInfo.uniqueId
                }
           

                const newMoment = {
                  id: docMoment.id,
                  subject: obj.subject,
                  title: obj.title,
                  location: obj.location,
                  coordinates: obj.coordinates,
                  favMoment: true,
                  date: obj.date,
                  mainCat: obj.mainCat,
                  secondCat: obj.secondCat,
                  description: obj.description,
                  name: userName,
                  imgUrl: userProfileImg,
                  uniqueId: userUniqueId,
                  creatorId: obj.creatorId,
                  createdTime: obj.createdTime,
                }

                return firebase.firestore().collection('activity').doc('moments').collection(favMoments[key].creatorId).doc(docMoment.id).collection('subscribers').get()
                  .then((subscribersSnapshot) => {
                    newMoment.subscribersNum = subscribersSnapshot.size
                  })
                  .then(() => {
                    commit('setLoadedFavMoments', newMoment)
                    console.log('newFavMomentLoaded', newMoment)

                  })
                  .catch((error) => {
                    console.log(error)

                  })

              } else {
                // doc.data() will be undefined in this case
                console.log('No such document!')

                // delete FavMoment if Moment is deleted
                firebase.firestore().collection('users').doc(user.id).collection('favMoments').doc(docMoment.id).delete()
                  .then(()=> {
                    let payloadDel = {
                      id: docMoment.id
                    }
                
                    commit('delFavMoments', payloadDel)

                  })
                  .catch((error) => {
                    console.log(error)

                  })
              }
            })
            .then(()=> {
              // commit('setLoadingFavMoments', false)

              setTimeout(function() {
                commit('setLoadingFavMoments', false)
              }, 3000)

            })
            .catch(function(error) {
              console.log('Error getting document:', error)
              // commit('setLoadingFavMoments', false)
              setTimeout(function() {
                commit('setLoadingFavMoments', false)
              }, 3000)

            })
        }

       


      }

    },

    loadFavEvents ({rootState, state, commit}, payload) {
      console.log('loadFavEvents')
      commit('setLoadingFavEvents', true)
      // commit('deleteLoadedFavMoments')
      
      let user = rootState.user.user

      // set User Friends
      // let friends = rootState.user.myFriends
      let favEvents = rootState.user.favEvents
      let loadedFavEvents = state.loadedFavEvents

      console.log('userStat', user)

      for (let key in Object.keys(favEvents)) {
        console.log(key, '=>', favEvents[key])


        var eventLoaded = loadedFavEvents.some(function(value) {
          return value.id === favEvents[key].id
        })

        if (!eventLoaded) {
          firebase.firestore().collection('activity').doc('events').collection(favEvents[key].dblat + ',' + favEvents[key].dblng).doc(favEvents[key].id).get()
            .then(function(docEvent) {
              if (docEvent.exists) {
                console.log('Document data:', docEvent.data())

                const obj = docEvent.data()

                let newEvent = {
                  id: docEvent.id,
                  subject: obj.subject,
                  title: obj.title,
                  location: obj.location,
                  coordinates: obj.coordinates,
                  favEvent: true,
                  date: obj.date,
                  link: obj.link,
                  mainCat: obj.mainCat,
                  secondCat: obj.secondCat,
                  description: obj.description,
                  imgUrl: obj.imgUrl,
                  standardImage: obj.standardImage,
                  creatorId: obj.creatorId,
                  uniqueId: obj.uniqueId,
                  createdTime: obj.createdTime,
                  dblat: obj.dblat,
                  dblng: obj.dblng,
                }

                return firebase.firestore().collection('activity').doc('events').collection(obj.dblat + ',' + obj.dblng).doc(docEvent.id).collection('subscribers').get()
                  .then((subscribersSnapshot) => {
                    newEvent.subscribersNum = subscribersSnapshot.size
                  })
                  .then(() => {
                    commit('setLoadedFavEvents', newEvent)
                    console.log('newFavEventLoaded', newEvent)
  
                  })
                  .catch((error) => {
                    console.log(error)
  
                  })

              } else {
                // doc.data() will be undefined in this case
                console.log('No such document!')

                // delete FavMoment if Moment is deleted
                firebase.firestore().collection('users').doc(user.id).collection('favEvents').doc(docEvent.id).delete()
                  .then(()=> {
                    let payloadDel = {
                      id: docEvent.id
                    }
              
                    commit('delFavEvents', payloadDel)

                  })
                  .catch((error) => {
                    console.log(error)

                  })
              }
            })
            .then(()=> {
              // commit('setLoadingFavEvents', false)
              setTimeout(function() {
                commit('setLoadingFavEvents', false)
              }, 3000)

            })
            .catch(function(error) {
              console.log('Error getting document:', error)
              // commit('setLoadingFavEvents', false)
              setTimeout(function() {
                commit('setLoadingFavEvents', false)
              }, 3000)
            })
        }
      }
    },
      
    


    createMoment({ commit, rootState, dispatch }, payload) {
      commit('setLoading', true)

      commit('clearError')
  
      let user = firebase.auth().currentUser
      if (user) { 
        const moment = {
          subject: 'moments',
          // name: getters.user.name,
          // imgUrl: getters.user.profileImg,
          title: payload.title,
          location: payload.location,
          coordinates: payload.coordinates,
          date: payload.date.toISOString(),
          description: payload.description,
          mainCat: payload.mainCat,
          secondCat: payload.secondCat,
          creatorId: user.uid,
          createdTime: new Date().toISOString()
        }
        // let key
        return firebase.firestore().collection('activity').doc('moments').collection(user.uid).add(moment)
          // .then(function(docRef) {
          //   key = docRef.id
          //   return key
          // })
          .then((data) => {
            const createdMoment = {
              id: data.id,
              path: data.path
            }
            firebase.firestore().collection('users').doc(user.uid).collection('createdMoments').doc(data.id).set(createdMoment)
              .then(() => {
                // created path
              })
              .catch((error) => {
                commit('setLoading', false)
                console.log(error)
              })

            console.log('newMomentCreated', data)

            let distanceReturn = distanceFunc({lat: rootState.user.user.filter.coordinates.lat, lng: rootState.user.user.filter.coordinates.lng}, payload.coordinates)
            let distance = distanceReturn.distance
            let calcDistance = distanceReturn.calcDistance

            const newMoment = {
              id: data.id,
              subject: 'moments',
              title: payload.title,
              location: payload.location,
              coordinates: payload.coordinates,
              date: payload.date.toISOString(),
              mainCat: payload.mainCat,
              secondCat: payload.secondCat,
              description: payload.description,
              distance: distance.toFixed(1),
              calcDistance: calcDistance.toFixed(1),
              subscribersNum: 0,
              favMoment: false,
              name: rootState.user.user.name,
              imgUrl: rootState.user.user.profileImg,
              creatorId: rootState.user.user.id,
              createdTime: new Date().toISOString(),
            }
            commit('setLoadedMoments', newMoment)
          })
          .then(() => {
            // console.log('loadedEvents', state.loadedEvents)
            // console.log('getAllPostsOrdered', state.getAllPostsOrdered)
            dispatch('filterPosts', {isFilterSet: true})
          })
          
          .then(() => {
            commit('setLoading', false)
            router.push('/timeline')
    
            
          })
          .catch((error) => {
            commit('setLoading', false)
            console.log(error)
          })
      }
    },


    deleteMoment({commit}, payload) {

      commit('clearError')
      let user = firebase.auth().currentUser
      if (user.uid === payload.creatorId) {
        console.log(payload)
        firebase.firestore().collection('activity').doc('moments').collection(user.uid).doc(payload.momentId).delete()
          .then(()=> {
            firebase.firestore().collection('activity').doc('moments').collection(user.uid).doc(payload.momentId).collection('subscribers').get()
              .then((subscribersSnapshot)  => {
                subscribersSnapshot.forEach((subscriberDoc) => {
                  firebase.firestore().collection('activity').doc('moments').collection(user.uid).doc(payload.momentId).collection('subscribers').doc(subscriberDoc.id).delete()
                    .then(function() {
                      console.log('Document successfully deleted!')
                    }).catch(function(error) {
                      console.error('Error removing document: ', error)
                    })
                })
              })
          })  
          .then(()=> {
            firebase.firestore().collection('users').doc(user.uid).collection('createdMoments').doc(payload.momentId).delete()
              .then(function() {
                console.log('Document successfully deleted!')
              }).catch(function(error) {
                console.error('Error removing document: ', error)
              })
          })
          .then(function() {
            console.log('Document successfully deleted!')
            commit('deleteFromLoadedMoments', payload.momentId)
            commit('deleteFromLoadedFavMoments', {id: payload.momentId})
            // router.go()
          }).catch(function(error) {
            console.error('Error removing document: ', error)
          })
      
      }
    },

    addFavMoment({commit}, payload) {
      commit('clearError')
      let user = firebase.auth().currentUser
      
      if (user) { 
        var ownDocRef = firebase.firestore().collection('users').doc(user.uid).collection('favMoments').doc(payload.id)
       
        let newFavMoment =  {
          id: payload.id,
          creatorId: payload.creatorId,
          date: payload.date,
        }

        ownDocRef.set(newFavMoment)
          .then(() => {
            firebase.firestore().collection('activity').doc('moments').collection(payload.creatorId).doc(payload.id).collection('subscribers').doc(user.uid)
              .set({
                subscriberId: user.uid,
                joinedDate: new Date().toISOString()
              })
          })
          .then(() => {
            let changeMoment = {
              id: payload.id,
              favMoment: true,
              subscribersNum: 1
            }
            commit('changeFavMoments', changeMoment)
            commit('setFavMoments', newFavMoment)

          })
          .catch(function(error) {
            console.error('Error writing document: ', error)
          })
      }
    },

    delFavMoment({commit}, payload) {
      commit('clearError')
      let user = firebase.auth().currentUser
      
      if (user) { 
        var ownDocRef = firebase.firestore().collection('users').doc(user.uid).collection('favMoments').doc(payload.id)

        let delFavMoment =  {
          id: payload.id,
          
        }

        ownDocRef.delete()
          .then(() => {
            firebase.firestore().collection('activity').doc('moments').collection(payload.creatorId).doc(payload.id).collection('subscribers').doc(user.uid)
              .delete()
          })
          .then(() => {
            let changeMoment = {
              id: payload.id,
              favMoment: false,
              subscribersNum: -1

            }
            commit('changeFavMoments', changeMoment)
            commit('delFavMoments', delFavMoment)
            commit('deleteFromLoadedFavMoments', delFavMoment)
          })
          .catch(function(error) {
            console.error('Error writing document: ', error)
          })
      }
    },

    addFavEvent({commit}, payload) {
      commit('clearError')
      let user = firebase.auth().currentUser
      
      if (user) { 
        var ownDocRef = firebase.firestore().collection('users').doc(user.uid).collection('favEvents').doc(payload.id)
        
        let newFavEvent = {
          id: payload.id,
          date: payload.date,
          creatorId: payload.creatorId,
          dblat: payload.dblat,
          dblng: payload.dblng
        }
        ownDocRef
          .set(newFavEvent)
          .then(() => {
            firebase.firestore().collection('activity').doc('events').collection(payload.dblat + ',' + payload.dblng).doc(payload.id).collection('subscribers').doc(user.uid)
              .set({
                subscriberId: user.uid,
                creatorId: payload.creatorId,
                joinedDate: new Date().toISOString()
              })
          })
          .then(()=>{
            let changeEvent = {
              id: payload.id,
              favEvent: true,
              subscribersNum: 1
            }
            commit('changeFavEvents', changeEvent)
            commit('setFavEvents', newFavEvent)

          })
          .catch(function(error) {
            console.error('Error writing document: ', error)
          })
      }
    },

    delFavEvent({commit}, payload) {
      commit('clearError')
      let user = firebase.auth().currentUser
      
      if (user) { 
        var ownDocRef = firebase.firestore().collection('users').doc(user.uid).collection('favEvents').doc(payload.id)

        let delFavEvent =  {
          id: payload.id,
          
        }

        ownDocRef.delete()
          .then(() => {
            firebase.firestore().collection('activity').doc('events').collection(payload.dblat + ',' + payload.dblng).doc(payload.id).collection('subscribers').doc(user.uid)
              .delete()
          })
          .then(() => {
            let changeEvent = {
              id: payload.id,
              favEvent: false,
              subscribersNum: -1

            }
            commit('changeFavEvents', changeEvent)
            commit('delFavEvents', delFavEvent)
            commit('deleteFromLoadedFavEvents', delFavEvent)

          })
          .catch(function(error) {
            console.error('Error writing document: ', error)
          })
      }
    },
  }
}